import currencyFormatter from 'currency-formatter';

export const formatCurrency = (amount: number, currency = 'NGN'): string => {
	return currencyFormatter.format(amount, { code: currency });
};
